
/**
 * 工作流-节点变量弹框
 * zxw
 * 创建时间 2026-05-09
 */

import CNF from '../../incs/Config';
import {
    Avatar,
    Space,
    Button,
    Typography,
    Tag,
    Popover,
} from 'antd';
import {
    RightOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

const NodeVariableModel = (props) => {

    return <div style={{
        position: 'absolute',
        top: 40,
        left: 18,
        width: 200,
        padding: '6px 8px',
        boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1)',
        border: '1px solid #00000033',
        borderRadius: 6,
        background: '#fff',
        fontSize: CNF.fontSizeSM,
    }}>
        <Space orientation='vertical' style={{ display: 'flex', }}>
            {
                props.graph && props.graph.getNodes().map(node => {
                    if (node.data?.key === 'End' || node.getZIndex() >= props.node.getZIndex()) return;
                    return <Popover
                        key={node.id}
                        placement='leftTop'
                        arrow={false}
                        title={null}
                        align={{
                            offset: [-12, 0],
                        }}
                        styles={{
                            container: {
                                padding: '4px 6px',
                            },
                        }}
                        content={<Space orientation='vertical' style={{ display: 'flex' }}>
                            {
                                Object.keys(node.data?.key === 'Start' ? node.data?.input.sys : node.data?.output).map((item, index) => {
                                    return <Button key={index} color='default' variant='text' style={{ width: '100%', justifyContent: 'left' }} onClick={(e) => {
                                        const path = node.getZIndex().toString() + (node.data?.key === 'Start' ? '/input/sys/' : '/output/') + item;
                                        props.setValue((props.value ? props.value : '') + CNF.APP_CONFIG_SPLIT + path + CNF.APP_CONFIG_SPLIT);
                                        props.cancel(false);
                                    }}><Space><Text>{item}</Text><Tag>string</Tag></Space></Button>
                                })
                            }
                        </Space>}
                    >
                        <Space>
                            <Avatar size={20} shape='square' icon={node.data.icon} style={{ background: node.data.theme, }} />
                            <Text ellipsis style={{ width: 152 }}>{node.data.title}</Text>
                            <RightOutlined />
                        </Space>
                    </Popover>
                })
            }
        </Space>
    </div>
};

export default NodeVariableModel;